var map = {
	"./frontend/components/atoms/button.style.scss": "7149",
	"./frontend/components/atoms/heading.style.scss": "c82a",
	"./frontend/components/atoms/text.style.scss": "2c37",
	"./frontend/components/molecules/cardDashed.style.scss": "35ab",
	"./frontend/components/molecules/cardNews.style.scss": "a662",
	"./frontend/components/organisms/footer.style.scss": "4890",
	"./frontend/components/organisms/header.style.scss": "5c62",
	"./frontend/components/organisms/heroSlider.style.scss": "b883",
	"./frontend/components/organisms/presentation-slider.style.scss": "45d7",
	"./frontend/components/templates/dialog.style.scss": "d063"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc49";